<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>Leider kein Interesse</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="closeFan">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<h2>{{ jobProfileItem.name }}</h2>
			<JonInfo>
				<template #message>
					<p>Der Job wird dir damit nicht mehr angezeigt.</p>
					<p>Falls du es dir anders überlegst, findest du ihn links unter <b>Kein Interesse</b>.</p>
				</template>
			</JonInfo>
			<!--<div class="mb-3">
				Soll der Job nur für diesen Wunschjob oder auch für weitere/künftige Wunschjobs ausgeschlossen werden?
			</div>
			<RadioGroup
				v-model="exclusionType"
				:options="exclusionTypeOptions"
				stacked
			/>-->
		</main>
		<footer>
			<Button
				text="Kein Interesse"
				icon="checkmark"
				:disabled="saving"
				:loading="saving"
				@click="exclude"
			/>
		</footer>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Button from "@/vue/common/Button";
import RadioGroup from "@/vue/common/form/RadioGroup";
import {isDefined} from "@/helper/Value";
import Exclusion from "@/api/application/job-profile/Exclusion";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job-result/exclusion/job-profile";
import JonInfo from "@/vue/common/JonInfo";

const EXCLUSION_TYPE_TOTAL = 'total';
const EXCLUSION_TYPE_JOB = 'job';

export default {

	components: {
		JonInfo,
		Button,
		Icon,
		RadioGroup,
	},

	data ()
	{
		return {
			exclusionType: undefined,
			exclusionTypeOptions: [
				{value: EXCLUSION_TYPE_JOB, text: 'Nur von diesem Wunschjob ausschließen'},
				{value: EXCLUSION_TYPE_TOTAL, text: 'Von ALLEN derzeitigen und künftigen Wunschjobs ausschließen'},
			],
			saving: false,
		};
	},

	computed: {
		...mapState('jobResult/exclusion/jobProfile', [
			'show',
			'jobProfileItem',
			'jobId',
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in']
			});
		},
		exclusionTypeValid ()
		{
			return isDefined(this.exclusionType);
		},
		dataValid ()
		{
			return this.exclusionTypeValid;
		}
	},

	methods: {
		...mapActions('jobResult/exclusion/jobProfile', [
			'close'
		]),
		async exclude ()
		{
			this.saving = true;

			try
			{
				await new Exclusion()
					.add()
					// .setType(this.exclusionType)
					.setType(EXCLUSION_TYPE_JOB)
					.setJobProfileId(this.jobProfileItem.id)
					.setJob(this.jobId)
					.call();

				this.closeFan({
					exclusionType: this.exclusionType,
					saved: true
				});
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
		closeFan (data)
		{
			this.exclusionType = undefined;

			this.close(data);
		}
	},
}
</script>
